export default __webpack_public_path__ + "static/use-3-18ec077566c2f1062b584bd985761f47.png";